import { c as _c } from "react/compiler-runtime";
import { SelectRole } from "@components/role/select-role";
import { Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { GROUP_MANAGING_ROLES } from "@pages/project-details/project-overview/change-management/change-management-utils";
import { getPrettyName } from "@utils/user-utils";
/**
 * Tells the user that the new project manager is not a member of the group of the project yet, and
 * lets them choose the role they will have in it, or that a group viewer will become a group
 * manager, since only the group and project managers of a group can manage its projects.
 */
export function GroupMembershipSection(t0) {
  const $ = _c(18);
  const {
    selectedMember,
    change,
    groupName,
    role,
    onRoleChange
  } = t0;
  let t1;
  if ($[0] !== selectedMember) {
    t1 = typeof selectedMember === "string" ? selectedMember : getPrettyName(selectedMember);
    $[0] = selectedMember;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <strong><var>{t1}</var></strong>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const name = t2;
  let t3;
  if ($[4] !== groupName) {
    t3 = groupName ? <>the group{" "}<strong><var>{groupName}</var></strong></> : "the group";
    $[4] = groupName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const group = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: 1
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== change || $[8] !== group || $[9] !== name) {
    t5 = <Text variant="bodyM">{change === "join" ? <>{name} is not a member of {group} yet. Select the role they will have when they are added to it.</> : <>{name} is a group viewer in {group}. Since group viewers cannot manage projects, they will become a group manager, keeping access to all the projects of the group.</>}</Text>;
    $[7] = change;
    $[8] = group;
    $[9] = name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== change || $[12] !== onRoleChange || $[13] !== role) {
    t6 = change === "join" && <SelectRole label="Role in group" roles={GROUP_MANAGING_ROLES} selectedRole={role} onChange={onRoleChange} variant="outlined" dataTestId="change-management-group-role" />;
    $[11] = change;
    $[12] = onRoleChange;
    $[13] = role;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <Stack sx={t4} data-testid="change-management-group-membership">{t5}{t6}</Stack>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}